(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-coupon/assets/javascripts/route-coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/route-coupon/assets/javascripts/route-coupon.js');
"use strict";


const DrawProvider = svs.components.tipsen.drawProvider.DrawProvider;
const RouteCouponView = svs.components.tipsen.routeCoupon.RouteCouponView;
const clx = svs.components.lbUtils.clx;
const TipsenModal = svs.components.tipsen.tipsenModal.TipsenModal;
const RouteCoupon = _ref => {
  let className = _ref.className;
  return React.createElement(TipsenModal, {
    isOpen: true
  }, React.createElement("div", {
    className: clx('pg_route_coupon', className)
  }, React.createElement(DrawProvider, null, React.createElement(RouteCouponView, null))));
};
setGlobal('svs.components.tipsen.routeCoupon.RouteCoupon', RouteCoupon);

 })(window);